import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class RenderChatTemplateArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string

  @Field(() => ID)
  templateId: string
}

export interface IRenderChatTemplate extends IAction<string, RenderChatTemplateArgs> {}
